import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import * as Icons from "lucide-react";

export default function Categories() {
  const [cats, setCats] = useState([]);

  useEffect(() => { api.get("/categories").then(({ data }) => setCats(data)); }, []);

  return (
    <div data-testid="categories-page">
      <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Life categories</h1>
      <p className="text-white/60 mt-2 max-w-xl">Eight pillars of adulting. Pick one and get going.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
        {cats.map(c => {
          const Icon = Icons[c.icon] || Icons.Sparkles;
          return (
            <Link key={c.category_id} to={`/categories/${c.category_id}`} data-testid={`category-card-${c.category_id}`}
              className="glass-card p-6 hover:scale-[1.02] hover:border-white/20 transition group">
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center mb-4"
                style={{ background: `${c.color}22`, color: c.color, boxShadow: `0 0 24px ${c.color}33` }}>
                <Icon/>
              </div>
              <div className="font-display font-bold text-xl group-hover:text-gradient-pink">{c.name}</div>
              <div className="text-sm text-white/65 mt-1.5">{c.description}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
